//
// FilelistFieldOptions
//
// Field options for type 'filelist'

import { observer } from 'mobx-react-lite'

import { FolderFieldOption } from './FolderFieldOption'
import { ListFieldOptions } from './ListFieldOptions'

export const FilelistFieldOptions = observer(function FileFieldOptions({
    field,
    selectModified,
    worksheet,
    onAction,
    setSelected,
    renderkeyprefix,
}) {
    if (!field) return null

    return (
        <>
            <FolderFieldOption
                field={field}
                selectModified={selectModified}
                worksheet={worksheet}
                onAction={onAction}
                setSelected={setSelected}
                renderkeyprefix={renderkeyprefix}
            />
            <ListFieldOptions
                field={field}
                selectModified={selectModified}
                worksheet={worksheet}
                onAction={onAction}
                setSelected={setSelected}
                renderkeyprefix={renderkeyprefix}
            />
        </>
    )
})
